/**
 * Counter printout: same fields as the website form, plus a draw box.
 * Not in the sitemap. Tammy prints a stack for the store.
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { applySeo } from '../../utils/seo';
import {
  CAKE_REQUEST_PATH,
  CAKE_REQUEST_PRINT_PATH,
  CAKE_REQUEST_CATEGORY,
  DEFAULT_CAKE_REQUEST_NOTICE,
  cakeRequestDropdowns,
} from './cakeRequestOptions';
import './cakeRequestPrint.css';

export default function CakeRequestPrint() {
  const [lists, setLists] = useState(() => cakeRequestDropdowns([]));

  useEffect(() => {
    applySeo({
      title: "Print cake request | Nanny B's Bakery",
      description: 'Printable custom cake request form for the bakery counter. Not a public marketing page.',
      canonicalPath: CAKE_REQUEST_PRINT_PATH,
      robots: 'noindex, nofollow',
    });
    fetch(`/api/product-options?category=${encodeURIComponent(CAKE_REQUEST_CATEGORY)}`)
      .then((res) => (res.ok ? res.json() : { groups: [] }))
      .then((data) => setLists(cakeRequestDropdowns(data.groups || [])))
      .catch(() => undefined);
  }, []);

  return (
    <div className="cake-print mx-auto max-w-3xl bg-white p-6 text-gray-900">
      <div className="cake-print-actions mb-4 flex flex-wrap gap-3 print:hidden">
        <button type="button" className="btn-primary" onClick={() => window.print()}>
          Print this form
        </button>
        <Link to={CAKE_REQUEST_PATH} className="btn-outline">
          Back to online form
        </Link>
      </div>

      <h1 className="font-display text-3xl font-bold">Nanny B&apos;s Bakery — Cake request</h1>
      <p className="mt-2 text-sm font-semibold">{DEFAULT_CAKE_REQUEST_NOTICE}</p>
      <p className="mt-1 text-sm">Staff will quote you. This is not a paid order.</p>

      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        <p>Name: _______________________________</p>
        <p>Phone: _______________________________</p>
        <p>Email: _______________________________</p>
        <p>Event date: _________________________</p>
        <p>Pickup date: ________________________</p>
        <p>Pickup time: ________________________</p>
        <p>Servings: ___________________________</p>
      </div>

      <h2 className="mt-6 font-semibold">Size (circle one)</h2>
      <p>{lists.sizes.join('  ·  ')}</p>
      <h2 className="mt-4 font-semibold">Flavour (circle one)</h2>
      <p>{lists.flavours.join('  ·  ')}</p>
      <h2 className="mt-4 font-semibold">Filling (circle one)</h2>
      <p>{lists.fillings.join('  ·  ')}</p>

      <p className="mt-4">Writing on cake: ______________________________________________</p>
      <p className="mt-2">Allergies: _____________________________________________________</p>
      <p className="mt-2">Design notes: __________________________________________________</p>
      <p className="mt-2">☐ I understand custom cakes need 72 hours notice.</p>
      <p className="mt-2">Design photos / info picture: show on your phone or attach to this sheet.</p>

      <h2 className="mt-8 font-semibold">Draw your design</h2>
      <div
        data-testid="cake-draw-box"
        className="cake-draw-box mt-2 min-h-[280px] rounded-lg border-2 border-dashed border-gray-400 bg-white"
      />
    </div>
  );
}
